"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _clsx = _interopRequireDefault(require("clsx"));

var _reactModal = _interopRequireDefault(require("react-modal"));

var _Button = _interopRequireDefault(require("../Button/Button"));

var _useToggler2 = _interopRequireDefault(require("../../hooks/useToggler"));

var _useTrigger2 = _interopRequireDefault(require("../../hooks/useTrigger"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable jsx-a11y/no-static-element-interactions */

/* eslint-disable jsx-a11y/click-events-have-key-events */

/**
 * The Modal component ...
 *
 * This component is an opinionated wrapper around <a href="https://github.com/reactjs/react-modal">ReactModal</a>.
 */
var Modal = function Modal(props) {
  var controlledIsOpen = props.isModalOpen,
      initialTrigger = props.trigger,
      modalScopeCSS = props.modalScopeCSS,
      modalTitle = props.modalTitle,
      disabled = props.disabled,
      _props$confirmButtonL = props.confirmButtonLabel,
      confirmButtonLabel = _props$confirmButtonL === void 0 ? 'Confirm' : _props$confirmButtonL,
      _props$cancelButtonLa = props.cancelButtonLabel,
      cancelButtonLabel = _props$cancelButtonLa === void 0 ? 'Cancel' : _props$cancelButtonLa,
      onOpen = props.onOpen,
      onConfirm = props.onConfirm,
      onCancel = props.onCancel,
      onClose = props.onClose,
      children = props.children,
      className = props.className,
      width = props.width,
      _props$tabIndex = props.tabIndex,
      tabIndex = _props$tabIndex === void 0 ? 0 : _props$tabIndex;

  var _useToggler = (0, _useToggler2.default)(controlledIsOpen || false),
      isOpen = _useToggler.isOpen,
      setOpen = _useToggler.setOpen,
      setClose = _useToggler.setClose,
      setToggle = _useToggler.setToggle;

  var _useTrigger = (0, _useTrigger2.default)(initialTrigger, {
    tabIndex: tabIndex,
    onClick: function onClick(event) {
      return handleOpenModal(trigger, event);
    },
    className: 'uk-modal__trigger'
  }),
      trigger = _useTrigger.trigger;

  _react.default.useEffect(function () {
    if (controlledIsOpen !== isOpen) {
      setToggle();
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, [controlledIsOpen]);

  var handleOpenModal = function handleOpenModal(trigger) {
    var _trigger$props, _trigger$props$childr, _trigger$props$childr2;

    if (disabled || trigger != null && (_trigger$props = trigger.props) != null && (_trigger$props$childr = _trigger$props.children) != null && (_trigger$props$childr2 = _trigger$props$childr.props) != null && _trigger$props$childr2.disabled) return null;
    setOpen();

    if (typeof onOpen === 'function') {
      onOpen({
        modalShow: true
      });
    }
  };

  var handleCancelModal = function handleCancelModal() {
    setClose();

    if (typeof onCancel === 'function') {
      onCancel({
        modalShow: false
      });
    }
  };

  var handleConfirmModal = function handleConfirmModal() {
    setClose();

    if (typeof onConfirm === 'function') {
      onConfirm({
        modalShow: false
      });
    }
  };

  var handleCloseModal = function handleCloseModal() {
    setClose();

    if (typeof onClose === 'function') {
      onClose({
        modalShow: false
      });
    }
  };

  var ModalActions = function ModalActions() {
    if (typeof onConfirm === 'function') {
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "uk-modal__actions"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "grid-x grid-margin-x"
      }, /*#__PURE__*/_react.default.createElement(_Button.default, {
        className: "cell shrink",
        color: "primary",
        outline: true,
        displayAsLink: true,
        label: cancelButtonLabel,
        onClick: handleCancelModal
      }), /*#__PURE__*/_react.default.createElement(_Button.default, {
        className: "cell shrink",
        color: "primary",
        label: confirmButtonLabel,
        onClick: handleConfirmModal
      })));
    }

    return /*#__PURE__*/_react.default.createElement(_Button.default, {
      closeButton: true,
      onClick: handleCloseModal
    });
  };

  var baseClass = (0, _clsx.default)('uk-modal__inner', onConfirm ? 'uk-modal--confirm' : '', className);
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, trigger, isOpen && /*#__PURE__*/_react.default.createElement("div", {
    onClick: function onClick(event) {
      return event.stopPropagation();
    }
  }, /*#__PURE__*/_react.default.createElement(_reactModal.default, {
    isOpen: true,
    ariaHideApp: false,
    portalClassName: (0, _clsx.default)('uk-modal', modalScopeCSS),
    className: {
      base: baseClass,
      afterOpen: 'uk-modal__inner--after-open',
      beforeClose: 'uk-modal__inner--before-close'
    },
    overlayClassName: {
      base: 'uk-modal__overlay',
      afterOpen: 'uk-modal__overlay--after-open',
      beforeClose: 'uk-modal__overlay--before-close'
    },
    bodyOpenClassName: "uk-modal--is-open",
    htmlOpenClassName: "uk-modal--is-open",
    shouldCloseOnOverlayClick: !confirmButtonLabel,
    onRequestClose: handleCloseModal,
    aria: {
      labelledby: 'dialog-label',
      describedby: 'dialog-desc'
    },
    style: width ? {
      content: {
        width: width
      }
    } : {}
  }, modalTitle && /*#__PURE__*/_react.default.createElement("h5", {
    className: "uk-modal__title",
    id: "dialog-label"
  }, modalTitle), /*#__PURE__*/_react.default.createElement("div", {
    className: "uk-modal__body",
    id: "dialog-desc"
  }, typeof children === 'function' ? children({
    isOpen: isOpen,
    setClose: setClose
  }) : children), typeof children !== 'function' ? /*#__PURE__*/_react.default.createElement(ModalActions, null) : null)));
};

Modal.propTypes = {
  /**
   * Show or hide the Modal (controlled)
   */
  isModalOpen: _propTypes.default.bool,

  /**
   * Trigger of the Modal
   * If the trigger isn't a React element, it will be wrapped within a <span/>
   */
  trigger: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.element]),

  /**
   * As the Modal is displayed in a ReactPortal, it may need to have its CSS scoped
   */
  modalScopeCSS: _propTypes.default.string,

  /**
   * Title of the Modal
   */
  modalTitle: _propTypes.default.string,

  /**
   * Label of the confirm Button
   */
  confirmButtonLabel: _propTypes.default.string,

  /**
   * Label of the cancel Button
   */
  cancelButtonLabel: _propTypes.default.string,

  /**
   * Callback function onOpen
   * Invoked when the Modal opens
   */
  onOpen: _propTypes.default.func,

  /**
   * Callback function onConfirm
   * Invoked on click of the confirm Button
   * This will setup the Modal as a confirm dialog
   */
  onConfirm: _propTypes.default.func,

  /**
   * Callback function onCancel
   * Invoked on click of the cancel Button
   */
  onCancel: _propTypes.default.func,

  /**
   * Callback function onClose
   * Invoked when the Modal closes
   */
  onClose: _propTypes.default.func,

  /**
   * Set the Modal as disabled
   */
  disabled: _propTypes.default.bool,

  /**
   * Change width props (default 600px)
   */
  width: _propTypes.default.string
};
Modal.defaultProps = {
  isModalOpen: false
};
var _default = Modal;
exports.default = _default;